import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d04c6a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = {
  key: 0,
  class: "error-code"
}
const _hoisted_4 = {
  key: 1,
  class: "error-time"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      appear: "",
      name: "slide-up"
    }, {
      default: _withCtx(() => [
        ($setup.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", {
                ref: "header",
                class: _normalizeClass(["modal-header", { 'align-left': $props.isAlignLeft }])
              }, _toDisplayString($props.title), 3 /* TEXT, CLASS */),
              _createElementVNode("section", {
                ref: "body",
                class: _normalizeClass(["modal-body", { 'align-left': $props.isAlignLeft }])
              }, [
                ($props.errorCode)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, " [오류코드 : " + _toDisplayString($props.errorCode) + "] ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($props.errorTime)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.errorTime), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", null, [
                  ($props.errorMessage.length > 0)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: $setup.DOMPurify.sanitize($props.errorMessage)
                      }, null, 8 /* PROPS */, _hoisted_5))
                    : (_openBlock(), _createElementBlock("p", _hoisted_6, " 예상치 못한 오류가 발생했습니다. 일시적인 현상이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 시도해주세요. "))
                ])
              ], 2 /* CLASS */),
              _hoisted_7,
              _createElementVNode("footer", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  class: "btn btn-confirm",
                  type: "button",
                  onClick: $setup.onClickConfirmButton
                }, " 확인 ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}